import { LoanStatusStopSettingsInput } from '@willow/graphql-iso/src/app';
import { SetLoanStatusForeclosureEvent } from '@willow/types-iso';

type StopSettingsForForeclosure = SetLoanStatusForeclosureEvent['stopSettings'];

export function getStopSettingsTextFromForeclosure(stopSettings: LoanStatusStopSettingsInput): string;
export function getStopSettingsTextFromForeclosure(stopSettings: StopSettingsForForeclosure): string;
export function getStopSettingsTextFromForeclosure(
  stopSettings: LoanStatusStopSettingsInput | StopSettingsForForeclosure,
): string {
  // Emails + documents paused are coupled for foreclosure, so we only need to check one
  const { emailsPaused, portalPayments } = stopSettings;

  if (emailsPaused && portalPayments === 'none') {
    return 'Do not communicate with borrowers or accept payments.';
  }
  if (emailsPaused && portalPayments === 'exact') {
    return 'Do not communicate with borrowers and accept exact payments only.';
  }
  if (emailsPaused) {
    return 'Do not communicate with borrower. Payments are accepted.';
  }

  if (portalPayments === 'none') {
    return 'Do not accept payments. Borrowers still receive statements.';
  }
  if (portalPayments === 'exact') {
    return 'Accept exact payments only. Borrowers still receive statements.';
  }

  return 'Borrowers still receive statements and payments are accepted.';
}
